// import { ReactComponent as Copy } from '@common/icons/Copy.svg';
// import { ReactComponent as EmailShare } from '@common/icons/EmailShare.svg';
// import { ReactComponent as FacebookShare } from '@common/icons/FacebookShare.svg';
// import { ReactComponent as InstagramShare } from '@common/icons/InstagramShare.svg';
// import { ReactComponent as ShareIcon } from '@common/icons/ShareIcon.svg';
// import { ReactComponent as TwitterShare } from '@common/icons/TwitterShare.svg';
import { ReactComponent as WhatsappShare } from '@common/icons/WhatsappShare.svg';
import Product from '@common/models/Product';
// import { copyTextToClipboard } from '@common/utils';
import { context } from '@common/utils/constants';
import FacebookFooter from '@images/Facebook.svg';
import GoogleFooter from '@images/Google.svg';
// import { ReactComponent as InstagramFooter } from '@images/Instagram.svg';
// import { ReactComponent as LinkedinFooter } from '@images/Linkedin.svg';
// import { ReactComponent as PinterestFooter } from '@images/Pintrest.svg';
import TwitterFooter from '@images/Twitter.svg';
// import { ReactComponent as YoutubeFooter } from '@images/Youtube.svg';
import React from 'react';
export interface ShareProps {
  className?: string;
  product: Product;
}

const Share: React.FunctionComponent<ShareProps> = ({ className = '', product }) => {
  const facebookURL = `https://www.facebook.com/dialog/feed?app_id=${context.FACEBOOK_APP_ID}&link=${product?.fullURL}&picture=${product?.images[0]}&name=${product?.title}&caption=${product?.shortDescription}&description=${product?.description}&redirect_uri=http://www.facebook.com`;

  const tweetContent = `Check out ${product?.title} at`;
  const twitterURL = `https://twitter.com/intent/tweet?text=${tweetContent}&url=${product?.fullURL}`;

  const whatsappContent = `Check out ${product?.title} at ${product?.fullURL}`;
  const whatsappURL = `https://api.whatsapp.com/send?text=${whatsappContent}`;

  const mailSubject = `Check out ${product?.title}`;
  const mailBody = `Check out ${product?.title} at ${product?.fullURL}`;
  const mailURL = `mailto:?subject=${mailSubject}&body=${mailBody}`;

  // const [isCopyToClipboardShown, setIsCopyToClipboardShown] = useState(false);

  return (
    <div className={`flex flex-col md:flex-row items-center justify-center md:justify-between  ${className}`}>
      <div className="flex w-full text-18 font-normal justify-center md:justify-start">
        <div className="leading-19 text-textColor" font-customisation="para-text" color-customisation="page-body-text">
          Like the product ? Share it!
        </div>
      </div>
      <div className={'flex justify-center md:justify-end items-center w-full mt-24 md:mt-0'}>
        <a href={whatsappURL} className="mr-20 md:mr-16">
          <WhatsappShare width={20} height={20} />
        </a>
        <a href={facebookURL} className="mr-30">
          <img src={FacebookFooter} className="fill-current h-20" />
        </a>
        <a href={twitterURL} className="mr-30">
          <img src={TwitterFooter} className="h-20" />
        </a>
        <a href={mailURL}>
          <img src={GoogleFooter} className="h-20" />
        </a>
      </div>
    </div>
  );
};

export default Share;
